import type { AtomModel } from '@models/atom.model';
import type { ResolvedVariableType } from '@stratumn/studio-shared';
import { type Dispatch, type SetStateAction, useEffect } from 'react';
import { StateMenuList, StateMenuRightColumn } from './stateMenu.style';
import VariableItem from './VariableItem';

type VariableMenuProps = {
  cursor: number | null;
  setCursor: Dispatch<SetStateAction<number>>;
  variablesByAction: AtomModel<{
    title: string;
    variableInfo?: { resolvedType?: ResolvedVariableType };
  }>[];
  handleVarClick: (index: number) => void;
  searchVar: string;
  selectedAction: string | null;
};

const VariableMenu = ({
  cursor,
  setCursor,
  variablesByAction,
  handleVarClick,
  searchVar,
  selectedAction
}: VariableMenuProps) => {
  useEffect(() => {
    if (selectedAction && cursor) {
      const selected = document.querySelector(`#variables-${cursor}`);
      if (selected) {
        selected?.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest'
        });
      }
    }
  }, [cursor, selectedAction]);

  return (
    <StateMenuRightColumn>
      <div>
        {cursor !== null ? (
          <>
            <h2 className="p-3 font-semibold text-gray-900 text-xs">
              Variables
            </h2>
            {variablesByAction.length > 0 ? (
              <StateMenuList>
                {variablesByAction.map((variable, i: number) => (
                  <VariableItem
                    id={`variables_${i}`}
                    key={`variables_${variable.id}_${i}`}
                    onClick={() => handleVarClick(i)}
                    onHover={!!selectedAction && i === cursor}
                    onMouseEnter={() => !!selectedAction && setCursor(i)}
                    searchVar={searchVar}
                    variable={variable}
                  />
                ))}
              </StateMenuList>
            ) : (
              <p style={{ textAlign: 'center' }}>No variables found</p>
            )}
          </>
        ) : (
          <div className="m-auto flex h-full w-3/4 items-center justify-center text-center text-gray-800">
            Search your workflows variable by typing in the search bar or by
            clicking on an action
          </div>
        )}
      </div>
    </StateMenuRightColumn>
  );
};

export default VariableMenu;
